export default {
  noData: 'No Data',
  page: 'Page',
  ofItem: '$index of $total item',
  ofItems: '$index of $total items',
  selectedItem: 'Selected $count item',
  selectedItems: 'Selected $count items'
};